import { Fragment, CSSProperties, ReactNode } from 'react'

import { HeaderVariant, LogoTop } from '~/components/LogoTop'
import { Footer } from '~/components/Footer'

export function ClearLayout({
  children,
  headerClassName = '',
  bgClassName = 'bg-gradient-purple-dark-top',
  leftAddon,
  style,
  noFooter = false,
  className = '',
  hideLogo = false,
  headerVariant,
}: {
  children: React.ReactElement | React.ReactElement[]
  headerClassName?: string
  leftAddon?: ReactNode
  style?: CSSProperties
  noFooter?: boolean
  bgClassName?: string
  className?: string
  hideLogo?: boolean
  headerVariant?: HeaderVariant
}): React.ReactElement {
  return (
    <Fragment>
      <div
        className={`box-content min-h-screen ${
          noFooter ? '' : 'pb-16'
        } m-auto flex flex-col ${bgClassName} ${className}`}
      >
        {!hideLogo && (
          <LogoTop
            className={headerClassName}
            isLeftLogo
            leftAddon={leftAddon}
            showOnLargeScreen
            style={style}
            variant={headerVariant}
          />
        )}
        {children}
      </div>
      {!noFooter && <Footer />}
    </Fragment>
  )
}
